import { Fragment } from 'react';
import { LuCheck } from 'react-icons/lu';
import { accentRgba } from './utils.js';

function StepPill({ step, accentColor }) {
	const complete = step.complete;
	return (
		<div
			className="flex items-center gap-2 rounded-full"
			style={{
				padding: '8px 14px 8px 8px',
				background: complete ? accentRgba(accentColor, 0.1) : '#f1f5f9',
				border: `1px solid ${complete ? accentRgba(accentColor, 0.25) : '#e2e8f0'}`,
				transition: 'all 0.2s',
			}}
		>
			<div
				className="flex items-center justify-center rounded-full"
				style={{
					width: 22,
					height: 22,
					background: complete ? accentColor : '#fff',
					color: complete ? '#fff' : '#cbd5e1',
					border: complete ? 'none' : '1px solid #e2e8f0',
				}}
			>
				{complete && <LuCheck size={13} strokeWidth={3} />}
			</div>
			<span
				style={{
					fontSize: 13,
					fontWeight: 500,
					color: complete ? '#1e293b' : '#475569',
					whiteSpace: 'nowrap',
				}}
			>
				{step.label}
			</span>
		</div>
	);
}

function OnboardingProgress({ steps, accentColor }) {
	const completedCount = steps.filter((s) => s.complete).length;
	const percent = Math.round((completedCount / steps.length) * 100);

	return (
		<section
			className="rounded-2xl bg-white"
			style={{
				border: '1px solid #f1f5f9',
				padding: 20,
				boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
			}}
		>
			<div
				className="flex items-center justify-between"
				style={{ marginBottom: 14 }}
			>
				<h2
					style={{
						fontSize: 16,
						fontWeight: 600,
						color: '#1e293b',
						margin: 0,
					}}
				>
					Internal Mobility Onboarding
				</h2>
				<span style={{ fontSize: 12, color: '#475569', fontWeight: 500 }}>
					{completedCount} of {steps.length}
				</span>
			</div>

			<div
				className="flex flex-wrap items-center"
				style={{ gap: 8, marginBottom: 16 }}
			>
				{steps.map((step, i) => {
					const connectorActive =
						step.complete && steps[i + 1]?.complete;
					return (
						<Fragment key={step.key}>
							<StepPill step={step} accentColor={accentColor} />
							{i < steps.length - 1 && (
								<div
									aria-hidden
									style={{
										flex: 1,
										minWidth: 12,
										height: 1,
										background: connectorActive
											? accentRgba(accentColor, 0.4)
											: '#e2e8f0',
										transition: 'background 0.3s ease',
									}}
								/>
							)}
						</Fragment>
					);
				})}
			</div>

			<div
				className="w-full overflow-hidden rounded-full"
				style={{ height: 6, background: '#f1f5f9' }}
			>
				<div
					style={{
						height: '100%',
						width: `${percent}%`,
						background: accentColor,
						transition: 'width 0.4s ease-out',
						borderRadius: 999,
					}}
				/>
			</div>
		</section>
	);
}

export default OnboardingProgress;
